import { render, staticRenderFns } from "./media.vue?vue&type=template&id=4d0f23e1&"
import script from "./media.vue?vue&type=script&lang=ts&"
export * from "./media.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports